@import 'src/styles/common/_colors.scss';

/* ----------------------------- BUTTONS -------------------------------- */


/* Force page breaks for testing multiple pages */
.page-break {
	page-break-before: always;
}

.aibutton {
	position: fixed;
	bottom: 0;
	right: 0;
	background-color: #4d912e;
	color: #ffffff;
	padding: 1rem 1.5rem;
	border-radius: 999rem;
	font-size: 1rem;
	border: none;
	font-weight: 700;
	margin: 10px 20px;
}

.helpaiicon {
	color: white;
	font-size: 24px;
	padding-right: 6px;
	vertical-align: middle;
}


.spinner {
	position: absolute;
	top: 50%;
	left: 50%;
}

.aimodalcontainer {
	width: 340px;
	height: 538px;
	position: fixed;
	border: 0px;
	transition-duration: 250ms;
	transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
	transition-property: opacity, top, bottom;
	z-index: 999999;
	right: 0;
	bottom: 0;
	margin: 20px 20px;
	background-color: rgb(255, 255, 255);
	border-radius: 0.571429rem;

	.table-content {
		width: 100%;
		overflow-x: scroll;
	}



	h1 {
		color: black;
		display: inline-flex;
		font-weight: 700;
		text-align: center;
		font-size: 16px;
		width: 100%;
		justify-content: space-between;
		padding: 12px 16px;
		border-radius: 9px 9px 0px 0px;
		background: rgb(77, 145, 46);
		color: rgb(255, 255, 255);
		margin-bottom: 0;

		span {
			font-size: 12px;
			margin-top: 5px;
		}
	}


}

.aibody {
	width: 100%;
	height: 100%;

	footer {
		padding: 12px 16px;

		textarea {
			appearance: none;
			transition: border-color 0.25s ease-in-out 0s, box-shadow 0.1s ease-in-out 0s, background-color 0.25s ease-in-out 0s, color 0.25s ease-in-out 0s, z-index 0.25s ease-in-out 0s;
			border: 1px solid rgb(216, 220, 222);
			border-radius: 4px;
			width: 100%;
			box-sizing: border-box;
			vertical-align: middle;
			font-family: inherit;
			padding: 0.714286em 0.857143em;
			min-height: 40px;
			line-height: 1.28571;
			font-size: 14px;
			background-color: rgb(255, 255, 255);
			color: rgb(47, 57, 65);
			overflow: auto;
			cursor: auto;
			resize: none;
			// min-height: 76px;
			// max-height: 120px;
		}
	}
}

.messagescontainer {
	-webkit-box-flex: 2;
	flex-grow: 2;
	padding-top: 1.07143rem;
	padding-left: 0.714286rem;
	padding-right: 1.07143rem;
	margin-left: 0.714286rem;
	margin-right: 0.357143rem;
	overflow: hidden auto;
	height: calc(100% - 284px);
	overflow-anchor: auto;

	input[type="check-box"] {
		accent-color: rgb(39, 39, 39);
	}
}

.sendbutton {
	color: white;
	margin-top: 10px;
	font-weight: 800;
	background: rgb(47, 57, 65);
	border-radius: 5px;
	width: 70px;
	padding: 1px 7px;
	border: 1px solid darkgray;
	cursor: pointer;
	float: right;


}

.disabled {
	pointer-events: none;
	opacity: 0.5;
}

.aimodalmessage {
	color: black;
	margin-left: 4px;
	margin-top: 4px;
	margin-bottom: 4px;
	font-size: 14px;
	background: rgb(248, 249, 249);
	border-radius: 6px;
	width: fit-content;
	padding: 6px 10px;
	width: 90%;


	.header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-weight: 800;
		font-size: 18px;

		.caret {
			font-size: 10px;
			color: white;
		}
	}

	[class*="d3-chart-"] {
		height: 450px;
		width: 100%;
		margin: 10px;

		svg {
			path {
				fill: none;
			}
		}
	}



	table {

		td,
		th {
			border: 1px solid #575757;
			padding: 8px;
		}

		tr:nth-child(even) {
			background-color: #f2f2f2;
		}

	}


}

.usermessage {
	background-color: #4d912e;
	color: white;
	white-space: pre-wrap;
}

.aimodalmessageline {
	display: flex;
}

.usermessageline {
	justify-content: flex-end;
}

.darkbackground {
	background-color: #3f3f3f !important;
}

.loadingmessage {
	span {
		clip-path: inset(0 3ch 0 0);
		animation: l 1s steps(4) infinite;
		font-family: monospace;
		width: 100px;

		@keyframes l {
			to {
				clip-path: inset(0 -1ch 0 0)
			}
		}
	}
}

.selectableTabContainer {
	color: black;
	display: flex;
	justify-content: space-between;
	padding: 7px 28px;
	align-items: center;
	border-bottom: 1px solid lightgray;

	button {
		background-color: black;
		color: white;
		border-radius: 5px;
		font-weight: 800;
		padding: 0px 10px;
	}

	button:disabled,
	button[disabled] {
		opacity: 0.5;
		pointer-events: none;
	}


	// padding-bottom: 6px;
	// padding-top: 6px;

	// div {
	// 	border-bottom: 1px solid rgb(47, 57, 65);
	// 	width: 50%;
	// 	text-align: center;
	// 	padding-bottom: 6px;
	// 	padding-top: 6px;
	// 	font-weight: bold;
	// }
}

.selectedTab {
	background-color: #3f3f3f;
	color: white;
}